<template>
  <div class="sidebar">
    <h3>Settings</h3>
    <div class="sidebar-menu">
        <span><router-link :to="{name: 'Role'}">Functions</router-link></span>
        <span><router-link :to="{name: 'Logs'}">Login Log</router-link></span>
        <span><router-link :to="{name: 'Requests'}">Requests</router-link></span>
        <span><router-link :to="{name: 'Requests'}">Subscription</router-link></span>
        <span><router-link :to="{name: 'Alerts'}">Alerts</router-link></span>
        <span><router-link :to="{name: 'Pricing'}">Pricing</router-link></span>
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style scoped lang="scss">
.sidebar {
    h3 {
        font-style: normal;
        font-weight: normal;
        font-size: 30px;
        line-height: 30px;
        color: #000000;
    }
    .sidebar-menu {
        display: flex;
        flex-direction: column;
        margin-top: 72px;
        span {
            margin-top: 30px;
            a {
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 16px;
                color: #817F7F;
            }
        }
    }
}
.router-link-active {
    color: #5051DB !important;
}
</style>
